import { useEffect, useState } from 'react';
import { Paper, Button, Table, TableBody, TableCell, TableRow,TableHead, Checkbox, TableSortLabel, Grid, Typography } from '@mui/material';
import DeletePopUp from '../../../../shared_elements/components/DeletePopUp';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { PartyList } from '../components';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { deletePartiesApi, getPartiesApi } from '../apiService';
import { checkApiStatus } from '../../../../utils';
import { useParams } from 'react-router-dom';
import { PageLoader, Pagination, STableLoader } from '../../../../shared_elements';
import NoRecordFound from '../../../../shared_elements/NoRecordFound';
import PartiesCRU from '../components/PartiesCRU';
import { enqueueSnackbar } from 'notistack';
import { ButtonLoader, ShowAttachments } from '../../../../shared_elements/components';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import { useDispatch, useSelector } from 'react-redux';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { getStorage } from '../../../../shared_elements/actionCreators';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const PartiesHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Parties`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header">
                    <PermissionWrapper extraProps={{ application: 'lease_revamp', feature: 'party', operationType: ['D'] }}>
                        <Checkbox
                            disableRipple
                            color='primary'
                            size='small'
                            onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)}
                            checked={item?.length === bulk?.ids?.length && item?.length > 0}
                        />
                    </PermissionWrapper>
                    Action(s) </TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('name', 'Name')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('role_id', 'Role')}</TableCell>
                <TableCell sx={{minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('contact_address', 'Contact Address')}</TableCell>
                <TableCell sx={{minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('concerned_person_name', 'Concerned Person')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('start_date', 'Start Date')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('end_date', 'End Date')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('country', 'Country')}</TableCell>
            </TableRow>
        </TableHead>
    );
};

const Parties = () => {
    const dispatch=useDispatch()
    const {fileUploadDetails} = useSelector((state) => state.leases);
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [partiesInfo, setPartiesInfo] = useState({ list: [], pagination: null });
    const [addEditParties, setAddEditParties] = useState({ mode: '', modal: false, data: null })
    const [deleteParties, setDeleteParties] = useState({ modal: false, data: null });
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [uploadfileList, setUploadfileList] = useState({ mode: '', modal: false, data: null });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const[isExport,seIsExport]=useState(false)
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})


    useEffect(() => {
        const uploadedFileData = getApiResponse("party", slug);
        getPartiesList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed',{ page_title: 'Parties'})
        setUploadFileProgressData({uploadedFileData});
    }, []);

    const getPartiesList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getPartiesApi(params, query), {}).then(response => {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            if (checkApiStatus(response)) {
                setPartiesInfo(response?.data?.data)
            }
        });
    dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"party"}))
    }

    const onDeleteParties = () => {
        const idsToDelete = deleteParties?.modal && deleteParties?.data?.id ? [deleteParties?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        setLoading(true);
        globalDeleteService(deletePartiesApi(params), { ids: idsToDelete })
        // { ids: bulk?.type === 'bulk' || bulk?.type === 'single' ? bulk?.ids.map(item => item?.id) : [deleteParties?.data?.id] }
        .then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                trackActivity('Item Deleted', { page_title: `Delete Party`, success_msg: response?.data?.message, item_ids: deleteParties?.data || bulk?.ids, response: response?.data })
                setDeleteParties({ modal: false, data: null });
                setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                getPartiesList('', { per_page: partiesInfo?.pagination?.per_page });
            }
            else {
                setLoading(false);
                enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                trackActivity('Item Deleted', { page_title: `Delete Party`, error_msg: response?.data?.message, item_ids: deleteParties?.data || bulk?.ids, response: response?.data })
            }
        });
    };

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getPartiesList('', { ...sortQuery, per_page: partiesInfo?.pagination?.per_page });
    }

    const onDeteAttchments = (deltedslug) => {
        setLoading(true);
        setUploadfileList({
            ...uploadfileList, data: {
                ...uploadfileList.data,
                attachments: uploadfileList?.data?.attachments.filter(item => item?.slug !== deltedslug)
            }
        });
        if (addEditParties?.modal) {
            setAddEditParties({
                ...addEditParties,
                data: {
                    ...addEditParties.data,
                    attachments: addEditParties.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getPartiesList('', { per_page: partiesInfo?.pagination?.per_page });
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getPartiesApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }

    const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "party",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments ,response}) => {
               setUploadFileProgressData({ progressRefs, attachments ,response});
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }});
                getPartiesList("fetch", { per_page: partiesInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }});
            }
        });
       setSlug({})
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Parties`, page_type: page_type, })
    }

    return (
        <>
        <LeasesBasicDetails/>
          <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
            <LeasesNav type="basic"/>
            <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='end' >
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Parties" type="basic" />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'0px', float:'right'}}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "party", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" color='error' size="small" >{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {partiesInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15}/> : <ArrowDownwardIcon/>} className='action-btn-start-icon' variant="outlined" size='small' onClick={() => {handleItemClicked('Export Button'); handleExport() }}> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "party", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'> <Button size="small" variant="contained" color="primary" startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' onClick={() => { setAddEditParties({ modal: true, data: { role_id: null, name: "", jurisdiction: "", contact_address: "" }, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Party</Button> </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: partiesInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                    <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                            <Table className="mui-table-format" stickyHeader>
                                <PartiesHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={partiesInfo?.list} toggleBulkOps={toggleBulkOps} />
                                <TableBody>
                                    {partiesInfo?.list?.length > 0 && (
                                        partiesInfo.list.map((item, index) => {
                                         const uploadedFileData = getApiResponse("party", item?.slug);
                                            return (
                                                <PartyList
                                                    slug={slug?.slug}
                                                    uploadedFileData={uploadedFileData }
                                                    uploadFileProgressData={uploadFileProgressData}
                                                    viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                    key={index}
                                                    item={item}
                                                    bulk={bulk}
                                                    viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                    viewFile={() => setUploadfileList({ modal: true, mode: 'file', data: item })}
                                                    deleteParties={deleteParties}
                                                    toggleBulkOps={toggleBulkOps}
                                                    onEdit={() => setAddEditParties({ modal: true, mode: 'edit', data: item, })}
                                                    onDelete={() => {
                                                        setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                        setDeleteParties({ modal: true, data: item });
                                                    }}
                                                    onView={() => setAddEditParties({ modal: true, mode: 'view', data: item, })}
                                                />
                                            );
                                        })
                                    )}
                                </TableBody>
                            </Table>
                        )}
                        {!skeletonLoader && !partiesInfo?.list?.length && <NoRecordFound />}
                    </div>
                    <Paper square>
                        <Pagination
                            pagination={partiesInfo?.pagination}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; getPartiesList("pageloader", { page: pageNum, per_page: partiesInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                            onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getPartiesList("pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                        />
                    </Paper>
                </Paper>
            </div>
             </Paper>
            {uploadfileList.modal ?
                <ShowAttachments
                    url='delete-attachment'
                    moduleName="Parties"
                    attachmentsData={uploadfileList}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setUploadfileList({ modal: false, data: null, mode:'' })}
                    onViewDisabled={addEditParties?.mode === 'view' || uploadfileList?.mode==='view'}
                    permissionKey='party'
                /> : null
            }
            {addEditParties.modal ?
                <PartiesCRU
                    params={params}
                    fileUpload={handleUpload}
                    partiesInfo={partiesInfo}
                    modeType={addEditParties?.mode}
                    addEditParties={addEditParties}
                    getResponseBack={() => {getPartiesList('', { per_page: partiesInfo?.pagination?.per_page }); setBulk({modal: false, ids: [], title: '', type: ''})}}
                    onToggleModal={() => setAddEditParties({ modal: false, mode: '', data: null })}
                    onOpenAttachments={() => setUploadfileList({ modal: true, data: addEditParties?.data, mode:'view' })}
                /> : null
            }
            {deleteParties.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deleteParties.modal}
                    title={bulk.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (partiesInfo?.list?.length || 0) ? 'Delete All Party' : 'Delete Selected Party') : 'Delete Party'}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        if (bulk.modal) {
                            setBulk({ modal: false, ids: [] });
                        } else {
                            setDeleteParties({ modal: false, data: null });
                            setBulk({ modal: false, ids: [], title: '', type: '' });
                        }
                    }}
                    onDeleteRecords={() => onDeleteParties()}
                /> : null}

            {
              revisionHistory.modal &&  
             <RevisionHistory 
              moduleName={"party"}
              revisionHistory={revisionHistory}
              onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
             />
            }    
              <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
              />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(Parties, { application: 'lease_revamp', feature: 'party', operationType: ['R'], leaseNav: true });
